import React from "react"
import TextField from "canvas-core-react/lib/TextField"
import { onlyNumberFormatInput } from "../../utils/utils"


const InputPlazo = props => {
	const { changeItem, error_input_plazo, plazo, max_term_range, min_term_range } = props
	const text_range = `Ingresa un plazo entre ${min_term_range} y ${max_term_range} días`

	const inputError = {
		label: "El plazo ingresado es menor al requerido",
		messages: ["El plazo ingresado es menor al requerido"]
	}

	const inputErrorM = {
		label: "El plazo ingresado excede al requerido",
		messages: ["El plazo ingresado excede al requerido"]
	}

	const handleOnChange = e => {
		const inputOfUser = e.target.value.replace(/[^0-9]/g, "")
		const onlyNumberRegularExpression = /^[0-9]*$/
		const validatorInput = onlyNumberRegularExpression.test(inputOfUser) && parseInt(inputOfUser) >= min_term_range && parseInt(inputOfUser) <= max_term_range

		if (inputOfUser === "0" || inputOfUser === "") {
			changeItem({ error_input_plazo: null, plazo: inputOfUser })
		}
		else if (parseInt(inputOfUser) < min_term_range) {
			changeItem({ error_input_plazo: inputError, plazo: inputOfUser })
		}
		else if (validatorInput) {
			changeItem({ error_input_plazo: null, plazo: inputOfUser })
		} else {
			changeItem({ error_input_plazo: inputErrorM, plazo: inputOfUser })
		}

	}

	return (
		<TextField
			id="dataEntry_plazo"
			data-testid="dataEntry_plazo"
			type="text"
			name="plazo"
			label="Plazo"
			maxLength={3}
			placeholder="Ingresa un plazo"
			secondaryLabel=" (Número de días)"
			supplementaryText={text_range}
			onChange={handleOnChange}
			error={error_input_plazo}
			value={onlyNumberFormatInput(plazo)}
		/>
	)
}

export default InputPlazo